module.exports = __webpack_public_path__ + "assets/mailjet.e3c2ed2a.svg";